import React, { useState, useMemo, useEffect, useDeferredValue } from 'react';
import { Modal, Form, Table, InputGroup, Pagination } from 'react-bootstrap';

const RubroSearchModal = ({ show, onHide, onSelectRubro, rubros = [] }) => {
    const [search, setSearch] = useState('');
    const deferredSearch = useDeferredValue(search);
    const [page, setPage] = useState(1);
    const itemsPerPage = 8;

    // Reset state on show
    useEffect(() => {
        if (show) {
            setSearch('');
            setPage(1);
        }
    }, [show]);

    useEffect(() => {
        setPage(1);
    }, [deferredSearch]);

    const filteredRubros = useMemo(() => {
        if (!deferredSearch) return rubros;
        const lower = deferredSearch.toLowerCase().trim();
        return rubros.filter(r => 
            String(r.c_rubro).toLowerCase().includes(lower) || 
            (r.d_rubro && r.d_rubro.toLowerCase().includes(lower))
        );
    }, [rubros, deferredSearch]);

    const paginatedRubros = useMemo(() => {
        const startIndex = (page - 1) * itemsPerPage;
        return filteredRubros.slice(startIndex, startIndex + itemsPerPage);
    }, [filteredRubros, page, itemsPerPage]);

    const handleSelect = (r) => {
        onSelectRubro(r);
        onHide(); // Cierra el modal, ya que se seleccionó solo uno
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title><i className="bi bi-search me-2"></i>Buscar Rubro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <InputGroup.Text><i className="bi bi-search"></i></InputGroup.Text>
                    <Form.Control
                        placeholder="Buscar por N° o Descripción"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1);
                        }}
                        autoFocus
                    />
                </InputGroup>
                
                <div style={{ minHeight: '350px' }}>
                    <Table striped bordered hover responsive size="sm" className="align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '20%' }}>N° de Rubro</th>
                                <th>Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedRubros.map((r) => (
                                <tr key={r.c_rubro} onClick={() => handleSelect(r)} style={{ cursor: 'pointer' }}>
                                    <td className="fw-bold">{r.c_rubro}</td>
                                    <td>{r.d_rubro}</td>
                                </tr>
                            ))}
                            {paginatedRubros.length === 0 && (
                                <tr>
                                    <td colSpan="2" className="text-center text-muted py-5">
                                        No se encontraron rubros coincidentes.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {filteredRubros.length > itemsPerPage && (
                    <Pagination className="justify-content-center mb-0 mt-3">
                        <Pagination.Prev disabled={page === 1} onClick={() => setPage(page - 1)} />
                        {Array.from({ length: Math.ceil(filteredRubros.length / itemsPerPage) }, (_, i) => (
                            <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => setPage(i + 1)}>
                                {i + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next disabled={page === Math.ceil(filteredRubros.length / itemsPerPage)} onClick={() => setPage(page + 1)} />
                    </Pagination>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default RubroSearchModal;
